import React, { ReactNode } from 'react';
import { Box, TextV2, SpacingStack } from '@withjoy/joykit';

type SummarySectionProps = {
  title: string;
  children: ReactNode;
  useStack?: boolean;
};

export const SummarySection = ({ title, children, useStack = false }: SummarySectionProps) => {
  return (
    <Box>
      <TextV2
        typographyVariant="body1"
        fontWeight="bold"
        color="mono12"
        marginBottom="8px"
      >
        {title}
      </TextV2>
      {useStack ? <SpacingStack gap="4px">{children}</SpacingStack> : children}
    </Box>
  );
};
